export const LISTING_ROWS_PER_PAGE = 18;
export const MAP_INITIAL_ZOOM_SIZE = 8;
export const MAP_MARGIN = [15, 15, 15, 15];
export const HOVER_DISTANCE = 30;
export const MAP_MIN_ZOOM_LEVEL_DESKTOP = 10;
export const MAP_MIN_ZOOM_LEVEL_MOBILE = 10;
export const MAP_MAX_ZOOM_LEVEL = 18;

export const MAP_INITIAL_LATITUDE = 52.345269;
export const MAP_INITIAL_LONGITUDE = 5.21436;
